package br.gov.go.pge.permanenciaweb.site.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.dom.svg.Path
import com.varabyte.kobweb.compose.dom.svg.ViewBox
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.IconRenderStyle
import com.varabyte.kobweb.silk.components.icons.createIcon

/**
 * Material `photo_camera` icon for the roster's photos action.
 *
 * Silk 0.25.1 does not ship a camera icon; this follows the same one-icon-per-file convention as
 * [BrushIcon] so the unused icon set stays out of the JS bundle.
 */
@Composable
internal fun CameraIcon(modifier: Modifier = Modifier) {
    createIcon(
        viewBox = ViewBox(0, 0, 24, 24),
        renderStyle = IconRenderStyle.Fill(),
        attrs = modifier.toAttrs(),
    ) {
        Path {
            d(
                "M9 2 7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 " +
                    "2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 " +
                    "5 2.24 5 5-2.24 5-5 5z",
            )
        }
    }
}
